import React, { useState } from "react";
import s from "./mediamonitoring-online.module.scss";
import SOCIAL_MONITORING from "../../assets/images/SOCIAL_MONITORING.jpg";
import LIVE_TRACKING from "../../assets/images/LIVE_TRACKING.jpg"
import REPUTATION_ANALYSIS from "../../assets/images/REPUTATION_ANALYSIS.jpg"
import HISTORICAL_ANALYSIS from "../../assets/images/HISTORICAL_ANALYSIS.jpg"
import CONTENT_ANALYSIS from "../../assets/images/CONTENT_ANALYSIS.jpg"
import WRITERS_RATING from "../../assets/images/WRITERS_RATING.jpg"

const MediamonitoringOnline = (props) => {

    const [mediaBlocks, setMediaBlocks] = useState(props.mediaBlocks);

    const getImageByImageText = (imageText) => {
        switch(imageText){
            case 'SOCIAL_MONITORING':
                return SOCIAL_MONITORING;
            case 'LIVE_TRACKING':
                return LIVE_TRACKING;
            case 'REPUTATION_ANALYSIS':
                return REPUTATION_ANALYSIS;
            case 'HISTORICAL_ANALYSIS':
                return HISTORICAL_ANALYSIS;
            case 'CONTENT_ANALYSIS':
                return CONTENT_ANALYSIS;
            case 'WRITERS_RATING':
                return WRITERS_RATING;
        }
    }

    const mediaBlocksData = mediaBlocks.map((k, i) => {return <div className={s.block} key={i}><span>{props.getValue(k.title)}</span><img src={getImageByImageText(k.title)} /></div>});

    return (
        <div className={s.MediamonitoringOnline}>
            <div className={s.backgroundBlock}>
                <div className={s.titleBlock}>
                    <span className={s.whiteText}>Echo </span>
                    <span className={s.blueText}>Analytics </span><br />
                    <span className={s.whiteText}>{ props.getValue('MEDIAMONITORING') } </span>
                    <span className={s.greenText}>{ props.getValue('IN_ONLINE') }</span><br />
                    <span className={s.descriptionText}>{ props.getValue('MEDIAMONITORING_DESCRIPTION_TEXT')}</span>
                </div>
                <div className={s.MediaBlocks}>
                    { mediaBlocksData }
                </div>
            </div>
        </div>
    )
}

export default MediamonitoringOnline;